import { render } from "./ProcessJob.vue?vue&type=template&id=388e3cb4"
import script from "./ProcessJob.vue?vue&type=script&lang=js"
export * from "./ProcessJob.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__